import { jsx } from '@amazon/vinyl-tsx'
import { LazyComponent } from '@/components/LazyComponent'
import { mountWhen } from '@/components/mountWhen'
import { fullPlayerOpened$ } from '@/playback/fullPlayerState'
import type { FullPlayerProps } from './FullPlayer'

/** The {@link FullPlayer}, loaded and built the first time it opens, then kept. */
export function FullPlayerOnFirstOpen(props: FullPlayerProps) {
    return mountWhen(fullPlayerOpened$, () => (
        <LazyComponent
            load={() => import('./FullPlayer')}
            create={({ FullPlayer }, p) => <FullPlayer {...p} />}
            props={props}
        />
    ))
}
